// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c1470841","455":"e73821fc"}[chunkId] + ".chunk.js";
};